<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { useProductStore } from '~/store/product/productStore';
import { MODAL_BRAND_VOUCHER } from '~/store/modalStore';

const productStore = useProductStore();
const {
  getBrandVoucherData
} = storeToRefs(productStore);

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)
</script>

<template>
  <Modal
:id="MODAL_BRAND_VOUCHER"
         :is-visible="isModalVisible"
         :title="$t('www.brand-voucher.modal.title')"
         @close="closeModal">
    <div>
      <div v-if="getBrandVoucherData.validTo" class="mb-1">
        {{ $t('www.brand-voucher.modal.date', {'value': getBrandVoucherData.advValue, 'date': getBrandVoucherData.validTo}) }}
      </div>

      <div class="underline-text mb-1">
        {{ $t('www.brand-voucher.modal.conditions') }}
      </div>
      <ul>
        <li>
          {{ $t('www.brand-voucher.modal.conditions.one_v2') }}
        </li>
        <li>
          {{ $t('www.brand-voucher.modal.conditions.two_v2') }}
        </li>
        <li>
          {{ $t('www.brand-voucher.modal.conditions.three_v2') }}
        </li>
      </ul>
    </div>
  </Modal>
</template>
